export const Detail_CP_More_TXT = []
Detail_CP_More_TXT["en"] = "More"
Detail_CP_More_TXT["th"] = "เพิ่มเติม"